import React from "react";
import { useNavigate } from "react-router-dom";
import TableLayout from "../../layouts/TableLayout/NewTableLayout";
import { useFetchAll } from "../../hooks/useFetchAll";
import { usePermissions } from "../../hooks/usePermissions";
import { PERMISSIONS } from "../../constants/access-control";
import { COLUMN_DEFINITIONS, PAGE_SIZE_OPTIONS } from "./table.config";
import { useGetInvoicesV2Query } from "../../redux/services/invoices/invoicesV2Api";

const InvoicesV2 = () => {
  const navigate = useNavigate();
  const { hasAnyPermission } = usePermissions();
  const canManageInvoices = hasAnyPermission([
    PERMISSIONS.INVOICES_CREATE,
    PERMISSIONS.INVOICES_EDIT,
  ]);
  const {
    pagination: { pageIndex, pageSize, setPagination },
    search: { handleGlobalSearch },
    queryResult: { data, isLoading },
  } = useFetchAll({
    queryHook: useGetInvoicesV2Query,
    defaultPageSize: 20,
  });

  return (
    <TableLayout
      id="invoices-v2"
      useStyles
      title="Invoices V2"
      loading={isLoading}
      columns={COLUMN_DEFINITIONS}
      data={data?.invoices || []}
      pagination={data}
      pageIndex={pageIndex}
      pageSize={pageSize}
      onPaginationChange={setPagination}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      handleEdit={(itemId) => navigate(`/invoices/v2/${itemId}/edit`)}
      fullTextSearch={handleGlobalSearch}
      noDelete
      hideCheckbox
      hideActions={!canManageInvoices}
      hideMainAction={!canManageInvoices}
      emptyState={{
        title: "No invoices",
        description: "Get started by adding an invoice",
      }}
      mainAction={{ onClick: () => navigate("/invoices/v2/create") }}
    />
  );
};

export default InvoicesV2;
